import React from 'react';

/** 그룹수업 카테고리 기본 목록 — 서버는 50자 이하 자유 문자열을 받는다 */
export const CATEGORY_OPTIONS = ['PILATES', 'YOGA', 'PT', 'SPINNING', 'GX', 'BOXING', 'KIDS', 'ETC'];
export const CATEGORY_MAX_LENGTH = 50;

const CUSTOM_VALUE = '__CUSTOM__';

/** 목록에 없는 값이면 직접 입력 상태로 시작해야 한다 */
export const isCustomCategory = (value: string | undefined | null) => !CATEGORY_OPTIONS.includes(value ?? '');

/**
 * 카테고리 선택창 + '직접 입력'.
 * 직접 입력 여부는 부모가 들고 있는다 — 수업 유형을 바꿀 때 기본 카테고리로 덮어쓰지 않으려면 부모가 알아야 해서.
 */
const GroupCategoryField = ({
    value,
    isCustom,
    onChange,
    selectStyle,
    inputStyle,
}: {
    value: string;
    isCustom: boolean;
    onChange: (next: { value: string; isCustom: boolean }) => void;
    selectStyle: React.CSSProperties;
    inputStyle: React.CSSProperties;
}) => {
    const empty = isCustom && !value.trim();
    return (
        <>
            <select
                style={selectStyle}
                value={isCustom ? CUSTOM_VALUE : value}
                onChange={(e) => {
                    const v = e.target.value;
                    if (v === CUSTOM_VALUE) onChange({ value: '', isCustom: true });
                    else onChange({ value: v, isCustom: false });
                }}
            >
                {CATEGORY_OPTIONS.map((c) => <option key={c} value={c}>{c}</option>)}
                <option value={CUSTOM_VALUE}>직접 입력</option>
            </select>
            {isCustom && (
                <>
                    <input
                        style={{ ...inputStyle, borderColor: empty ? '#EF4444' : undefined }}
                        value={value}
                        maxLength={CATEGORY_MAX_LENGTH}
                        onChange={(e) => onChange({ value: e.target.value, isCustom: true })}
                        placeholder="카테고리를 입력해주세요 (최대 50자)"
                        autoFocus={!value}
                    />
                    {empty && <span style={{ fontSize: 11, color: '#EF4444' }}>카테고리를 입력해주세요</span>}
                </>
            )}
        </>
    );
};

export default GroupCategoryField;
